module.exports = __webpack_public_path__ + "static/media/mockup--light.07038bf8.png";